import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalMessageService, GlobalMessageType, OccEndpointsService } from '@spartacus/core';
import { LaunchDialogService, SpinnerComponent } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { CustomerData } from 'src/app/models/customer.model';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { KNBR_CASE_CREATE_UPLOAD_FILE, KNBR_CASE_UPDATE, KN_BR_CUSTOMER_CURRENT } from 'src/constants/api.endpoints.constant';
import { NgClass } from '@angular/common';

@Component({
  selector: 'kn-br-case-update-dialog',
  templateUrl: './kn-br-case-update-dialog.component.html',
  styleUrls: ['./kn-br-case-update-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None, //
  imports: [ReactiveFormsModule, SpinnerComponent, NgClass],
})
export class KnBrCaseUpdateDialogComponent implements OnInit {
  @Input() ticketInfo: any;

  customerContextData$: Observable<CustomerData> = this.knBrCustomerContextService.get$;
  submitted: boolean = false;
  caseUpdateForm: UntypedFormGroup;
  hasImage: any;
  showSpinner: any;
  customerId: any;
  uploadedFileObjects: any = [];
  comment: any;
  subscription = new Subscription();
  disableUpdateButton = false;

  constructor(
    private knBrCustomerContextService: KnBrCustomerContextService,
    private fb: UntypedFormBuilder,
    protected modalService: NgbActiveModal,
    protected http: HttpClient,
    protected globalMessageService: GlobalMessageService,
    protected cdr: ChangeDetectorRef,
    protected launchDialogService: LaunchDialogService,
    protected vcr: ViewContainerRef,
    private endPointService: OccEndpointsService
  ) {}

  ngOnInit(): void {
    this.knBrCustomerContextService.getActiveCustomerNumber().subscribe((response) => {
      this.customerId = response ? response : KN_BR_CUSTOMER_CURRENT;
    });
    this.initForm();
  }

  initForm() {
    this.caseUpdateForm = this.fb.group({
      updateComment: [null, [Validators.maxLength(512)]],
      fileInput: [''],
    });
  }

  onFileSelected(event: any, dragFiles?: File[]) {
    const file: File = dragFiles ? dragFiles[0] : event.target.files[0];

    if (!file) {
      return;
    }

    const fileSizeInKB = file.size / 1024;

    this.uploadedFileObjects.push({
      file, // Store the actual File object for later upload
      fileName: file.name,
      fileSize: fileSizeInKB.toFixed(2),
    });

    this.caseUpdateForm.controls['fileInput'].reset();
    this.caseUpdateForm.updateValueAndValidity();
    this.cdr.detectChanges();
  }

  removeSelectedFile(fileObj: any) {
    this.uploadedFileObjects = this.uploadedFileObjects.filter((obj: any) => obj !== fileObj);
    this.cdr.detectChanges();
  }

  resetTheDialogForm() {
    this.caseUpdateForm.reset();
    this.uploadedFileObjects = [];
  }

  handleUpdateClick() {
    this.disableUpdateButton = true;

    if (this.caseUpdateForm.valid) {
      const payload = this.caseUpdateForm.getRawValue();
      const formData = this.getUpdatedPayload(payload);

      console.log('Update Payload', formData);

      this.sendRequestToUpdateCase(formData);
    } else {
      this.caseUpdateForm.markAllAsTouched();
      this.disableUpdateButton = false;
    }
  }

  sendRequestToUpdateCase(formData: FormData) {
    const caseUpdateUrl = this.endPointService.buildUrl(KNBR_CASE_UPDATE(this.customerId));

    this.subscription.add(
      this.http.post(caseUpdateUrl, formData).subscribe(
        (response: any) => {
          this.disableUpdateButton = false;

          if (response?.updated) {
            this.globalMessageService.add('Case Updated successfully', GlobalMessageType.MSG_TYPE_CONFIRMATION);
            this.dismissModal('update');
          } else {
            this.globalMessageService.add(
              'Case not updated due to system issue. Try again later.',
              GlobalMessageType.MSG_TYPE_ERROR
            );
          }
        },
        () => {
          this.disableUpdateButton = false;
          this.globalMessageService.add(
            'Case not updated due to system issue. Try again later.',
            GlobalMessageType.MSG_TYPE_ERROR
          );
        }
      )
    );
  }

  getUpdatedPayload(payload: any): FormData {
    const caseForm = {
      ticketID: this.ticketInfo.ticketId,
      svcCaseNumber: this.ticketInfo.svcCaseNumber,
      comment: payload.updateComment,
    };

    const formData = new FormData();

    formData.append(
      'caseForm',
      new Blob([JSON.stringify(caseForm)], {
        type: 'application/json',
      })
    );

    this.uploadedFileObjects.forEach((fileObj: any) => {
      formData.append('files', fileObj.file);
    });

    return formData;
  }

  dismissModal(reason?: any): void {
    this.modalService.close(reason);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
